import { createStore } from "@tanstack/react-store";
import {
  DEFAULT_FILTERS,
  type TFilters,
  type TFiltersStore,
  type TFiltersStoreDispatch,
} from "./filters.config";
import { filtersSchema, isTabFilterKey } from "./filters.schema";

export const filtersStore = createStore<TFiltersStore>({
  filters: DEFAULT_FILTERS,
});

export const filtersDispatch: TFiltersStoreDispatch = {
  hydrateFilters: (filters): void => {
    filtersStore.setState((state) => {
      const result = filtersSchema.safeParse({
        ...state.filters,
        ...filters,
      });

      return result.success
        ? { ...state, filters: result.data }
        : state;
    });
  },
  replaceFilterGroup: (filterGroup, filters): void => {
    filtersStore.setState((state) => {
      const result = filtersSchema.safeParse({
        ...state.filters,
        [filterGroup]: filters,
      });

      return result.success
        ? { ...state, filters: result.data }
        : state;
    });
  },
  updateFilters: (filter, value): void => {
    filtersStore.setState((state) => {
      const filterGroup = isTabFilterKey(filter)
        ? "tabs"
        : (Object.keys(state.filters) as Array<keyof TFilters>)
          .find((group) => filter in state.filters[group]);

      if (!filterGroup) {
        return state;
      }

      const filters = {
        ...state.filters,
        [filterGroup]: {
          ...state.filters[filterGroup],
          [filter]: value,
        },
      } as TFilters;

      const result = filtersSchema.safeParse(filters);

      return result.success
        ? { ...state, filters: result.data }
        : state;
    });
  },
};
